// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2mr_Z","bigColWidth":"Table_bigColWidth__3nzEY","biggerColWidth":"Table_biggerColWidth__1gJiM","row":"Table_row__1LW0A","col":"Table_col__10fl5"};